import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3e34f0ec"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["src"]
const _hoisted_2 = ["src"]

import { computed, ref } from 'vue';
import { useI18n } from 'vue-i18n';

import uaFlag from './flags/ua.png';
import enFlag from './flags/en.png';

import SingleSelect from '@ui-kit/inputs/select/SingleSelect.vue';
import { useSelectClientDataManager } from '@ui-kit/inputs/select/select-data-managers/use-select-client-data-manager';
import { Lang } from '@/i18n/messages';
import { saveLang } from '@/i18n/local-storage';

interface LangObj {
  id: Lang;
  name: string;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'LangSelect',
  setup(__props) {

// https://icons8.com/icon/set/flags/fluent for images
const { locale, t } = useI18n();

const flagsPerLang: Record<Lang, unknown> = {
  [Lang.UA]: uaFlag,
  [Lang.EN]: enFlag,
}

const languages = ref<LangObj[]>(Object.values(Lang).map((lang) => ({
  id: lang,
  name: t(`lang.${lang}`),
})));

const selectedLang = ref(locale.value);
const selectedLangObj = computed<LangObj | undefined>(() => {
  return languages.value.find(({id}) => id === selectedLang.value);
});
function setLang(lang: LangObj) {
  selectedLang.value = lang.id;
  locale.value = lang.id;
  saveLang(lang.id);
}

const manager = useSelectClientDataManager({
  data: languages,
  selected: selectedLangObj,
  hideSelected: true,
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(SingleSelect, {
    "disable-search": "",
    "data-manager": _unref(manager),
    "model-value": _unref(selectedLangObj),
    "hide-empty": "",
    "onUpdate:modelValue": setLang
  }, {
    "selected-option": _withCtx(({ value }) => [
      _createElementVNode("img", {
        class: "lang-flag",
        src: flagsPerLang[value.id]
      }, null, 8, _hoisted_1),
      _createTextVNode(" " + _toDisplayString(value.name), 1)
    ]),
    option: _withCtx(({ option }) => [
      _createElementVNode("img", {
        class: "lang-flag",
        src: flagsPerLang[option.id]
      }, null, 8, _hoisted_2),
      _createTextVNode(" " + _toDisplayString(option.name), 1)
    ]),
    _: 1
  }, 8, ["data-manager", "model-value"]))
}
}

})